export class UserSelfEmployed {
  id: number;
  user_id: number;
  identification_card: string;
  siret: string;
  status_message: string;
  status: number;
  id_card: string;
  id_card_status: number;
  validated_at: Date;
  validate_at: Date;
  stripe_connect_id: string;
  stripe_connect_status: string;
  stripe_connect_onboarding_step: string;
  stripe_connect_onboarding_url: string;
  stripe_connect_onboarding_emails_sent: string;
  stripe_charges_enabled: boolean;
  stripe_payouts_enabled: boolean;
  created_at: Date;
  updated_at: Date;
}